__turbopack_context__.v({
  "TaxInfo": "QPVItG_TaxInfo",
  "TaxInfoButton": "QPVItG_TaxInfoButton",
  "TaxInfoIcon": "QPVItG_TaxInfoIcon",
  "TaxLineItemLabel": "QPVItG_TaxLineItemLabel",
  "TaxTooltip": "QPVItG_TaxTooltip",
  "TaxTooltipContent": "QPVItG_TaxTooltipContent",
});
